import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';

const isValidTokenFormat = (token) => {
  const parts = token.split('.');
  return parts.length === 3; // Debe tener 3 partes: encabezado, carga útil y firma
};

const ProtectedRoute = ({ element }) => {
  const token = localStorage.getItem('token');

  // Verifica si el token existe y si tiene un formato válido
  if (!token || !isValidTokenFormat(token)) {
    return <Navigate to="/localizador/login" replace />;
  }

  return element;
};

ProtectedRoute.propTypes = {
  element: PropTypes.node.isRequired,
};

export default ProtectedRoute;